import {CommonModule} from '@angular/common';
import {Component, computed, input} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';

import {UntypedFormGroup} from '@angular/forms';
import {
  CalculationMappingValue,
  CombinedAttributeMappingValue,
  LogicalOperator,
  MappingRule,
  SimpleMappingValue,
} from '@em/shared/mapping-engine/domain-models';
import {expandCollapseAnimation, EmIconModule} from '@em/shared/ui';
import {TranslateModule} from '@ngx-translate/core';
import {EmOperandWithIconModule} from '../operand-with-icon/operand-with-icon.module';
import {MatChipsModule} from '@angular/material/chips';

@Component({
  selector: 'em-readable-mapping-rule',
  templateUrl: './readable-mapping-rule.component.html',
  styleUrls: ['./readable-mapping-rule.component.scss'],
  animations: [expandCollapseAnimation],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    EmIconModule,
    EmOperandWithIconModule,
    MatChipsModule,
  ],
})
export class EmReadableMappingRuleComponent {
  mappingRule = input.required<MappingRule>();

  mappingRuleFormGroup: UntypedFormGroup | null | undefined;

  simpleMappingValue = computed(
    () => this.mappingRule().mappingValue as SimpleMappingValue,
  );
  combinedAttrMappingValue = computed(
    () => this.mappingRule().mappingValue as CombinedAttributeMappingValue,
  );
  calculationMappingValue = computed(
    () => this.mappingRule().mappingValue as CalculationMappingValue,
  );

  getGroupClass(
    currentOperator: LogicalOperator | null | undefined,
    parentOperator: LogicalOperator | null | undefined,
  ) {
    if (currentOperator) {
      return 'logic-group--' + currentOperator.toLowerCase();
    } else if (parentOperator) {
      if (parentOperator === 'and') {
        return 'logic-group--or';
      } else {
        return 'logic-group--and';
      }
    }
    return '';
  }
}
